<template>
  <v-app>
    <v-app-bar app clipped-left dark v-if="isAuthenticated">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer">
        <v-icon>far fa-bars</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title>
        <img src="../static/logo.svg" height="30"> RU - Tourenplaner
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!--<v-text-field flat solo-inverted prepend-icon="far fa-search" label="Suche"></v-text-field>-->
      <v-spacer></v-spacer>
      <v-btn text v-on:click="syncData">
        <v-icon>far fa-sync</v-icon>
      </v-btn>
      <v-btn text class="user" @click="dialogUser = true">
        <v-icon>far fa-user</v-icon>
        {{ profile.firstname }} {{ profile.lastname}}
      </v-btn>
      <v-btn text @click="showErrorDialog()">
        <v-icon>far fa-bug</v-icon>
      </v-btn>
      <v-btn text v-on:click="logout">
        <v-icon>far fa-sign-out</v-icon>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer permanent :mini-variant="drawer" app dark clipped v-if="isAuthenticated">
      <v-list dense>
        <template v-for="(item, index) in items">
          <template v-if="item.sub === undefined && checkAccess(item.level)">
            <v-list-item :key="index" :to="{name: item.route_name}"
                         v-bind:class="{ 'mb-4': item.space }">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-else-if="item.sub !== undefined && checkAccess(item.level)">
            <v-list-group
              :key="item.text"
              :prepend-icon="item.icon"
              v-model="item.active">
              <v-list-item slot="activator">
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item>
              <v-list-item v-for="(subitem, i) in item.sub"
                           :key="i"
                           :to="{name: subitem.route_name}"
                           v-if="checkAccess(subitem.level)">
                <v-list-item-icon>
                  <v-icon>{{ subitem.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ subitem.text }}</v-list-item-title>
              </v-list-item>
            </v-list-group>
          </template>
          <v-divider :key="item.text" v-if="item.space" class="mb-4 mt-4"></v-divider>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-main v-if="isAuthenticated">
      <v-container pa-8 fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
    <router-view v-if="!isAuthenticated"></router-view>
    <v-dialog v-model="dialogUser" max-width="400">
      <v-card>
        <v-card-title class="headline" primary-title>
          Passwort ändern
        </v-card-title>

        <v-card-text>
          <v-container grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="password"
                  type="password"
                  label="Passwort"
                  counter
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="passwordCheck"
                  type="password"
                  label="Passwort wiederholen"
                  counter
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogUser = false">Abbrechen</v-btn>
          <v-btn text color="primary" @click="updatePassword()"
                 :disabled="password !== passwordCheck || password === ''">
            Speichern
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loader></loader>
  </v-app>
</template>

<script>
import axios from 'axios'
import loader from './components/partials/_loader'
import * as Sentry from '@sentry/browser'

export default {
  components: {
    loader
  },
  name: 'app',
  data: () => ({
    user: {
      firstname: 'Vorname',
      lastname: 'Nachname'
    },
    password: '',
    passwordCheck: '',
    dialogUser: false,
    drawer: true,
    items: [
      {
        icon: 'far fa-home',
        text: 'Dashboard',
        space: true,
        route_name: 'dashboard',
        level: ['ROLE_USER', 'ROLE_RESTRICTED']
      },
      {icon: 'far fa-envelope', text: 'Aufträge', route_name: 'duties', level: ['ROLE_USER', 'ROLE_RESTRICTED']},
      {
        icon: 'far fa-envelope-open',
        text: 'Grüne Karte',
        route_name: 'duty_new',
        level: ['ROLE_USER', 'ROLE_RESTRICTED']
      },
      {
        icon: 'far fa-clipboard-list',
        text: 'Touren',
        space: true,
        route_name: 'tour',
        level: ['ROLE_USER', 'ROLE_RESTRICTED']
      },
      {
        icon: 'far fa-chart-bar',
        text: 'Statistiken',
        space: true,
        route_name: 'stats',
        level: ['ROLE_USER']
      },
      {
        icon: 'far fa-server',
        text: 'Stammdaten',
        active: false,
        sub: [
          {
            icon: 'far fa-clipboard',
            text: 'Tourvorlagen',
            route_name: 'tour_template',
            level: ['ROLE_USER']
          },
          {
            icon: 'far fa-building',
            text: 'Orte',
            route_name: 'districts',
            level: ['ROLE_USER']
          },
          {
            icon: 'far fa-road',
            text: 'Straßen',
            route_name: 'streets',
            level: ['ROLE_USER']
          },
          {
            icon: 'far fa-address-card',
            text: 'Unternehmen',
            route_name: 'companies',
            level: ['ROLE_USER']
          },
          {
            icon: 'far fa-truck',
            text: 'Fahrzeuge',
            route_name: 'vehicles',
            level: ['ROLE_ADMIN']
          }
        ],
        level: ['ROLE_USER']
      }
    ]
  }),
  mounted () {
    if (!this.isAuthenticated) {
      this.$router.push({name: 'login'}).catch(() => {})
    }
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    profile () {
      if (this.$store.getters.getProfile.data !== undefined) {
        return this.$store.getters.getProfile.data
      }
      return {firstname: '', lastname: '', roles: []}
    }
  },
  methods: {
    updatePassword () {
      let profile = this.profile
      profile.password = this.password
      this.$store.commit('updatePassword', profile)
      this.dialogUser = false
      this.password = ''
      this.passwordCheck = ''
    },
    logout () {
      this.$store.dispatch('AUTH_LOGOUT')
        .then(() => {
          this.$router.push({name: 'login'}).catch(() => {})
        })
    },
    syncData () {
      if (this.isAuthenticated) {
        this.$store.dispatch('getAllCities') // dispatch loading
        this.$store.dispatch('getAllDistricts') // dispatch loading
        this.$store.dispatch('getAllStreets') // dispatch loading
        this.$store.dispatch('getAllTour') // dispatch loading
        this.$store.dispatch('getAllTourTemplates') // dispatch loading
        this.$store.dispatch('getAllDevices') // dispatch loading
        this.$store.dispatch('getAllDuties') // dispatch loading
        this.$store.dispatch('getAllCompanies') // dispatch loading
        this.$store.dispatch('getAllVehicles') // dispatch loading
        this.$store.dispatch('USER_REQUEST')
      } else {
        this.$store.dispatch('AUTH_LOGOUT')
        this.$router.push({name: 'login'}).catch(() => {})
      }
    },
    checkAccess (roles) {
      return this.isAuthenticated && roles.some(r => this.profile.roles.includes(r))
    },
    showErrorDialog () {
      Sentry.captureMessage('User feedback')
      Sentry.showReportDialog({user: {name: this.profile.firstname + ' ' + this.profile.lastname, email: this.profile.email}})
    }
  },
  created () {
    if (!this.isAuthenticated) {
      this.$router.push({name: 'login'}).catch(() => {})
    } else {
      axios.interceptors.response.use(undefined, function (err) {
        return new Promise(function (resolve, reject) {
          if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
            // if you ever get an unauthorized, logout the user
            this.$store.commit('AUTH_LOGOUT')
            this.$router.push({name: 'login'}).catch(() => {})
          }
          throw err
        })
      })

      this.syncData()
    }
  }
}
</script>

<style lang="scss">
  @import "scss/settings";

  body {
    .headline {
      font-size: 2.5rem;
      line-height: 3rem;
      padding-left: 1rem;
      border-left: 0.25rem solid $primary-color;
      margin-bottom: 1rem;
      color: $secondary-color;
    }

    .title {
      font-size: 1.5rem;
      line-height: 2rem;
      margin-bottom: 1rem;
      color: $secondary-color;
    }

    .divider {
      background-color: transparent;
    }

    #app {
      background: rgb(100, 66, 107);
      background: radial-gradient(circle, rgba(100, 66, 107, 1) 0%, rgba(203, 100, 76, 1) 100%);

      .v-app-bar {
        background-color: #212121;
      }

      main .v-main__wrap {
        @media only screen and (min-width: 1600px) {
          margin: 5rem;
        }
        background-color: #dcdcdc;
      }

      .v-toolbar {
        .user {
          i {
            padding-right: 0.5rem;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue